// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d8d748f3","450":"9d993057","455":"bd0d6a5b","762":"a58b92aa","857":"b9c2777f","977":"2d91dd3e"}[chunkId] + ".chunk.js";
};